import { useState, useMemo, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import isEqual from "lodash/isEqual.js";
import { listTasks } from "../api/todo.js";
import { removeDuplicatedTasks } from "../helpers/removeDuplicatedTasks.js";
import { filterTodos } from "../helpers/todo.js";
import { withQueryParams } from "../helpers/withQueryParams.js";
import { useAxiosProvider } from "../providers/AxiosProvider.js";
import { usePrevious } from "./usePrevious.js";
import "../helpers/parseArrayQueryParam.js";
import "../todo-list.types.js";
import "react/jsx-runtime";
import "axios";
const useTodos = ({
  key,
  clinicReferenceId,
  auth,
  baseURL,
  disabled,
  filter,
  pageableProps: initialPageProps
}) => {
  var _a, _b;
  const axios = useAxiosProvider();
  const [pageProps, setPageProps] = useState(initialPageProps);
  const queryKey = [key, { clinicReferenceId, ...filter, ...pageProps }];
  const enabled = !disabled && !!clinicReferenceId && !!auth && !!baseURL;
  const [allTodos, setAllTodos] = useState([]);
  const query = useQuery({
    queryKey,
    queryFn: withQueryParams(listTasks(axios)),
    cacheTime: 0,
    refetchOnWindowFocus: true,
    enabled
  });
  const origins = useMemo(() => filter.origins, [filter.origins]);
  const previousOrigins = usePrevious(origins);
  const sort = useMemo(() => pageProps.sort, [pageProps.sort]);
  const previousSort = usePrevious(sort);
  const fetchedTodos = useMemo(
    () => {
      var _a2, _b2;
      return ((_b2 = (_a2 = query == null ? void 0 : query.data) == null ? void 0 : _a2.content) == null ? void 0 : _b2.reduce((accumulator, todo) => {
        if (accumulator.some((currentTodo) => currentTodo.referenceId === todo.referenceId))
          return accumulator;
        return [...accumulator, todo];
      }, [])) ?? [];
    },
    [(_a = query == null ? void 0 : query.data) == null ? void 0 : _a.content]
  );
  const filteredTodos = useMemo(() => allTodos.reduce(removeDuplicatedTasks, []), [allTodos]);
  useEffect(() => {
    setPageProps(initialPageProps);
  }, [initialPageProps]);
  useEffect(() => {
    if (!isEqual(origins, previousOrigins) || !isEqual(sort, previousSort))
      setAllTodos([]);
  }, [origins, sort, previousOrigins, previousSort]);
  useEffect(() => {
    setAllTodos(fetchedTodos.filter(filterTodos));
  }, []);
  useEffect(() => {
    var _a2;
    if (!enabled || !((_a2 = query == null ? void 0 : query.data) == null ? void 0 : _a2.content) || (query == null ? void 0 : query.isFetching))
      return;
    setAllTodos((currentTodos) => [...currentTodos, ...fetchedTodos.filter(filterTodos)]);
  }, [fetchedTodos, enabled, (_b = query == null ? void 0 : query.data) == null ? void 0 : _b.content, query == null ? void 0 : query.isFetching]);
  useEffect(() => {
    setAllTodos(fetchedTodos.filter(filterTodos));
  }, [clinicReferenceId, initialPageProps, fetchedTodos]);
  return { ...query, todos: filteredTodos, queryKey, setPageProps, setAllTodos };
};
export {
  useTodos
};
